(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer {
    constructor() {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-drawer-overlay]');
      this.itemsContainer = document.querySelector('[data-cart-items]');
      this.subtotalElement = document.querySelector('[data-cart-subtotal]');
      this.countElements = document.querySelectorAll('[data-cart-count]');
      this.loadingElement = document.querySelector('[data-cart-loading]');
      this.emptyState = document.querySelector('[data-cart-empty]');
      this.filledState = document.querySelector('[data-cart-filled]');

      this.isUpdating = false;

      this.bindEvents();
    }

    bindEvents() {
      // Open drawer buttons
      document.querySelectorAll('[data-cart-drawer-toggle]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      // Close buttons
      document.querySelectorAll('[data-cart-drawer-close]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          // Don't prevent default for links (continue shopping)
          if (btn.tagName !== 'A') {
            e.preventDefault();
          }
          this.close();
        });
      });

      // Overlay click
      this.overlay?.addEventListener('click', () => this.close());

      // Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });

      // Quantity changes and remove buttons (delegated)
      this.itemsContainer?.addEventListener('click', (e) => {
        const quantityBtn = e.target.closest('[data-quantity-change]');
        if (quantityBtn) {
          e.preventDefault();
          this.handleQuantityChange(quantityBtn);
          return;
        }

        const removeBtn = e.target.closest('[data-remove-item]');
        if (removeBtn) {
          e.preventDefault();
          this.handleRemoveItem(removeBtn);
        }
      });

      // Intercept add to cart forms
      document.addEventListener('submit', (e) => {
        const form = e.target.closest('form[action="/cart/add"], form[action*="/cart/add"]');
        if (form) {
          this.handleAddToCart(e, form);
        }
      });
    }

    async handleAddToCart(e, form) {
      e.preventDefault();

      if (this.isUpdating) return;

      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn?.textContent;

      try {
        this.setLoading(true);
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = '...';
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Add to cart failed');
        }

        await this.refresh();
        this.open();
      } catch (error) {
        console.error('Add to cart error:', error);
        // Could show a toast notification here
      } finally {
        this.setLoading(false);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      }
    }

    async handleQuantityChange(btn) {
      if (this.isUpdating) return;

      const line = parseInt(btn.dataset.line);
      const change = parseInt(btn.dataset.quantityChange);
      const item = btn.closest('[data-cart-item]');
      const quantityElement = item?.querySelector('[data-quantity]');
      const currentQty = parseInt(quantityElement?.textContent || '1');
      const newQty = Math.max(0, currentQty + change);

      await this.updateItem(line, newQty);
    }

    async handleRemoveItem(btn) {
      if (this.isUpdating) return;

      const line = parseInt(btn.dataset.line);
      await this.updateItem(line, 0);
    }

    async updateItem(line, quantity) {
      try {
        this.setLoading(true);

        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity })
        });

        if (!response.ok) throw new Error('Update failed');

        await this.refresh();
      } catch (error) {
        console.error('Update error:', error);
      } finally {
        this.setLoading(false);
      }
    }

    async refresh() {
      try {
        // Fetch updated cart drawer HTML
        const response = await fetch('/?section_id=cart-drawer');
        const html = await response.text();

        // Parse the response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Update items container
        const newItems = doc.querySelector('[data-cart-items]');
        if (newItems && this.itemsContainer) {
          this.itemsContainer.innerHTML = newItems.innerHTML;
        }

        // Update subtotal
        const newSubtotal = doc.querySelector('[data-cart-subtotal]');
        if (newSubtotal && this.subtotalElement) {
          this.subtotalElement.textContent = newSubtotal.textContent;
        }

        // Update all count badges
        const newCountEl = doc.querySelector('[data-cart-count]');
        const newCount = newCountEl?.textContent?.trim() || '0';
        this.countElements.forEach(el => {
          el.textContent = newCount;
          el.classList.toggle('header__cart-count--hidden', newCount === '0');
        });

        // Re-query count elements in case they were updated
        this.countElements = document.querySelectorAll('[data-cart-count]');

        // Update empty/filled states
        const isCartEmpty = doc.querySelector('[data-cart-empty]:not(.hidden)');

        if (this.emptyState && this.filledState) {
          if (isCartEmpty) {
            this.emptyState.classList.remove('hidden');
            this.filledState.classList.add('hidden');
          } else {
            this.emptyState.classList.add('hidden');
            this.filledState.classList.remove('hidden');
          }
        }
      } catch (error) {
        console.error('Refresh error:', error);
      }
    }

    setLoading(loading) {
      this.isUpdating = loading;
      this.loadingElement?.classList.toggle('cart-drawer__loading--visible', loading);
    }

    open() {
      this.drawer?.classList.add('cart-drawer--open');
      this.drawer?.setAttribute('aria-hidden', 'false');
      this.overlay?.classList.add('cart-drawer__overlay--visible');
      document.body.classList.add('cart-drawer-open');

      // Focus the close button
      const closeBtn = this.drawer?.querySelector('[data-cart-drawer-close]');
      if (closeBtn) {
        closeBtn.focus();
      }
    }

    close() {
      this.drawer?.classList.remove('cart-drawer--open');
      this.drawer?.setAttribute('aria-hidden', 'true');
      this.overlay?.classList.remove('cart-drawer__overlay--visible');
      document.body.classList.remove('cart-drawer-open');

      // Return focus to toggle button
      const toggleBtn = document.querySelector('[data-cart-drawer-toggle]');
      if (toggleBtn) {
        toggleBtn.focus();
      }
    }

    isOpen() {
      return this.drawer?.classList.contains('cart-drawer--open') || false;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.cartDrawer = new CartDrawer();
    });
  } else {
    window.cartDrawer = new CartDrawer();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    // Menu toggle is inside header, but menu and overlay are outside
    const menuToggle = header.querySelector('[data-mobile-menu-toggle]');
    const menuClose = document.querySelector('[data-mobile-menu-close]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const mobileOverlay = document.querySelector('[data-mobile-overlay]');

    if (!menuToggle || !mobileMenu || !mobileOverlay) return;

    function openMenu() {
      mobileMenu.classList.add('is-open');
      mobileOverlay.classList.add('is-active');
      menuToggle.setAttribute('aria-expanded', 'true');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mobile-menu-open');

      // Focus the close button
      if (menuClose) {
        menuClose.focus();
      }
    }

    function closeMenu() {
      mobileMenu.classList.remove('is-open');
      mobileOverlay.classList.remove('is-active');
      menuToggle.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mobile-menu-open');

      // Return focus to toggle button
      menuToggle.focus();
    }

    // Toggle button click
    menuToggle.addEventListener('click', function() {
      const isOpen = mobileMenu.classList.contains('is-open');
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Close button click
    if (menuClose) {
      menuClose.addEventListener('click', closeMenu);
    }

    // Overlay click
    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', closeMenu);
    }

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMenu();
      }
    });

    // Focus trap
    mobileMenu.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;

      const focusableElements = mobileMenu.querySelectorAll(
        'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
